import { render, staticRenderFns } from "./sendSyncMessageButton.vue?vue&type=template&id=4fcd1688&"
import script from "./sendSyncMessageButton.vue?vue&type=script&lang=js&"
export * from "./sendSyncMessageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fcd1688')) {
      api.createRecord('4fcd1688', component.options)
    } else {
      api.reload('4fcd1688', component.options)
    }
    module.hot.accept("./sendSyncMessageButton.vue?vue&type=template&id=4fcd1688&", function () {
      api.rerender('4fcd1688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sync/sendSyncMessageButton.vue"
export default component.exports